import { type SectionFilterConfig } from "@/configuration/types";
import { fetchJSON } from "@/src/requests/utils/fetch-json";

export async function getSectionFilterConfig(): Promise<SectionFilterConfig> {
  return fetchJSON<SectionFilterConfig>("/api/section-filter-config");
}
